import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import pt from "./locales/pt.json";
import esPE from "./locales/es-PE.json";
import esCL from "./locales/es-CL.json";
import esUY from "./locales/es-UY.json";

/**
 * All locale codes the app supports. Spanish regional variants are kept as
 * separate locale files so terminology can diverge over time without
 * affecting the European Spanish translation.
 */
export const SUPPORTED_LANGUAGES = [
  "es",
  "en",
  "it",
  "pt",
  "es-PE",
  "es-CL",
  "es-UY",
] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      "es-PE": { translation: esPE },
      "es-CL": { translation: esCL },
      "es-UY": { translation: esUY },
    },
    fallbackLng: {
      "es-PE": ["es", "en"],
      "es-CL": ["es", "en"],
      "es-UY": ["es", "en"],
      it: ["en"],
      pt: ["es", "en"],
      default: ["en"],
    },
    lng: localStorage.getItem("language") || undefined,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
